module.exports = __webpack_public_path__ + "static/user-most-likely-to-recommend-44af0824f90bbd644aaf0cf6ee4a7326.svg";